import zstd from "zstd-codec";
let simple = null;

function getCoder() {

  if (simple) {
    return Promise.resolve(simple);
  }

  return new Promise((resolve) => {

    zstd.ZstdCodec.run((zstd) => {

      simple = new zstd.Simple();

      resolve(simple);

    });

  });

}

export default {getCoder};
